module.exports = __webpack_public_path__ + "img/stock4.85326cc5.png";